/**
 * Workflow-state *type* (the category a workflow state belongs to) — the
 * portal's fixed taxonomy for type-safe comparisons on issue states.
 */
export enum IssueStateType {
  Triage = 'triage',
  Backlog = 'backlog',
  Unstarted = 'unstarted',
  Started = 'started',
  Completed = 'completed',
  Canceled = 'canceled',
}
